import React from "react";
import { downloadCourseReport } from "../../api/apiClient";
import { TenantContext } from "../../contexts/TenantContext";
import Icon from "./reportsList/Icon";
import { downloadErrorMessage, groupReports, reportCountLabel } from "./reportsList/reportsModel";
import "./reportsList/reportsList.css";

const FULL_EXPORT = "full_export";

function ReportRow({ report, state, disabled, onDownload }) {
  const { busy, done, error } = state;
  return (
    <div className="rp" data-testid={`report-${report.id}`}>
      <span className="ri" aria-hidden="true"><Icon n={report.icon} s={17} w={2} /></span>
      <div>
        <h3>{report.title}</h3>
        <p>{report.description}</p>
      </div>
      <button type="button" className={`btn btn-o${done ? " done" : ""}`} disabled={busy || disabled}
        aria-label={`Download ${report.title} as CSV`} onClick={() => onDownload(report.id)}>
        <Icon n="download" />
        {busy ? "Downloading…" : done ? "Downloaded" : <>Download <b>.csv</b></>}
      </button>
      {error && <div className="err" role="alert">{error}</div>}
    </div>
  );
}

export default function ReportsTab({ course }) {
  const tenantContext = React.useContext(TenantContext) || {};
  const user = tenantContext.effectiveUser || tenantContext.user || {};
  const roles = Array.isArray(user.roles) ? user.roles : [];
  const [status, setStatus] = React.useState({});

  const groups = groupReports(roles);
  const patch = (id, next) => setStatus((prev) => ({ ...prev, [id]: { ...prev[id], ...next } }));

  async function handleDownload(reportId) {
    if (!course?.id || status[reportId]?.busy) return;
    patch(reportId, { busy: true, error: "" });
    try {
      await downloadCourseReport(course.id, reportId);
      patch(reportId, { done: true });
    } catch (err) {
      patch(reportId, { error: downloadErrorMessage(err) });
    } finally {
      patch(reportId, { busy: false });
    }
  }

  const full = status[FULL_EXPORT] || {};
  return (
    <div className="rl-root">
      <div className="rh">
        <div>
          <h2>Class reports</h2>
          <p>
            Download class-scoped attendance, test, skill sheet and completion data for this assigned class.
            Reports are generated on demand.
          </p>
        </div>
        <button type="button" className="btn btn-p" disabled={full.busy || !course?.id} onClick={() => handleDownload(FULL_EXPORT)}>
          <Icon n="download" />
          {full.busy ? "Exporting…" : full.done ? "Exported" : "Export all as ZIP"}
        </button>
      </div>
      {full.error && <div className="err top" role="alert">{full.error}</div>}

      <div className="list">
        {groups.map((g) => (
          <React.Fragment key={g.key}>
            <div className="grp"><b>{g.label}</b><span>{reportCountLabel(g.reports.length)}</span></div>
            {g.reports.map((r) => (
              <ReportRow key={r.id} report={r} state={status[r.id] || {}} disabled={!course?.id} onDownload={handleDownload} />
            ))}
          </React.Fragment>
        ))}
      </div>
      <p className="inc">Export all includes every report above in one ZIP package.</p>
    </div>
  );
}
